import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { change, reset } from 'redux-form';
import PropTypes from 'prop-types';
import ReactRoutePropTypes from 'react-router-prop-types';
import EventForm from './EventForm';
import {
  communicationCalendarSaveMutation,
  communicationRemoveWithChildren,
} from '../../../shared/queries/Communication';
import GraphQl from '../../../GraphQL';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  changeLoadingFalse,
  changeLoadingTrue,
} from '../../../redux/actions/loadingActions';
import {
  attendanceCalendarEventConfirmationListByEventId,
  calendarListByFilter,
  calendarNotificationListByCalendarId,
  eventCalendarFindByCommunicationId,
} from '../../../shared/queries/Calendar';
import { relationObjectListByParamsQuery } from '../../../shared/queries/RelationObject';
import { formatPhone, updatePendency } from '../../../shared/utils/smartutils';
import { ATTENDANCE_CONFIRMATION_STATUS } from '../../../shared/utils/constants';

const EventFormHandler = ({
  t,
  match,
  history,
  dispatch,
  foreignToggleClose,
  event,
}) => {
  const [formOn, setFormOn] = useState(false);
  const [calendars, setCalendars] = useState([]);
  const [dto, setDto] = useState({ id: 0, communication: { id: 0 } });
  const [calendarNotifications, setCalendarNotifications] = useState([]);
  const [relatedObjects, setRelatedObjects] = useState([]);
  const [mappedChartData, setMappedChartData] = useState();
  const [metricsData, setMetricsData] = useState();

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  function onBackClick() {
    if (foreignToggleClose) {
      foreignToggleClose();
    } else {
      history.goBack();
    }
  }

  const loadCalendarAlerts = (calendar) => {
    const alertFilter = { id: calendar.value };
    const calendarNotificationQuery =
      calendarNotificationListByCalendarId(alertFilter);
    GraphQl(calendarNotificationQuery, {})
      .then((res) => {
        const notifications = res.calendarNotificationListByCalendarId.map(
          (not) => ({
            ...not,
          })
        );
        setCalendarNotifications(notifications);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadEventMetrics = () => {
    showLoading();
    function formatConfirmationStatus(status) {
      return t(`screens.mnt_evento_calendario.confirmationStatus.${status}`);
    }
    const mutation = attendanceCalendarEventConfirmationListByEventId(dto.id);
    GraphQl(mutation, {})
      .then((res) => {
        const mappedData =
          res.attendanceCalendarEventConfirmationListByEventId.map((item) => ({
            ...item,
            responsableCellPhone: item.responsableCellPhone
              ? formatPhone(item.responsableCellPhone)
              : null,
            responsableCellPhone1: item.responsableCellPhone1
              ? formatPhone(item.responsableCellPhone1)
              : null,
            responsablePhone: item.responsablePhone
              ? formatPhone(item.responsablePhone)
              : null,
            confirmationStatus: formatConfirmationStatus(
              item.confirmationStatus
            ),
          }));

        setMetricsData(mappedData);
        const getChartData = () => {
          const dataMap = new Map();
          dataMap.set(ATTENDANCE_CONFIRMATION_STATUS.NOT_ANSWERED, 0);
          dataMap.set(ATTENDANCE_CONFIRMATION_STATUS.CONFIRMATION_YES, 0);
          dataMap.set(ATTENDANCE_CONFIRMATION_STATUS.CONFIRMATION_NO, 0);
          res.attendanceCalendarEventConfirmationListByEventId.forEach(
            (dado) => {
              dataMap.set(
                dado.confirmationStatus,
                dataMap.get(dado.confirmationStatus) + 1
              );
            }
          );
          return dataMap;
        };
        const chartData = getChartData();
        const ArrayChart = [...chartData];
        const mappedChart = [
          ArrayChart[0][1],
          ArrayChart[1][1],
          ArrayChart[2][1],
        ];
        setMappedChartData(mappedChart);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  const loadAllCalendar = () => {
    const filter = {};
    const query = calendarListByFilter(filter);
    GraphQl(query, {})
      .then((res) => {
        res.calendarListByFilter = res.calendarListByFilter.map((item) => ({
          ...item,
          value: item.id,
          label: item.name,
        }));
        setCalendars(res.calendarListByFilter);
      })
      .catch(() => {});
  };

  const loadRelatedObjects = () => {
    const query = relationObjectListByParamsQuery(true, false, true, true);
    GraphQl(query, {})
      .then((res) => {
        res.relationObjectListByParams = res.relationObjectListByParams.map(
          (item) => ({
            ...item,
            value: item.id,
            label: item.description,
          })
        );
        setRelatedObjects(res.relationObjectListByParams);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const removeEvent = (id, deleteChildren) => {
    showLoading();
    const mutation = communicationRemoveWithChildren(id, deleteChildren);
    GraphQl(mutation, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('notifications.delete_success')
        );
        onBackClick();
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
        updatePendency(dispatch);
      });
  };

  const handleSubmit = (values) => {
    showLoading();
    const mutation = communicationCalendarSaveMutation(values);
    GraphQl(mutation, {
      title: values.communication.title,
      htmlContent: values.communication.htmlContent,
      textContent: values.communication.textContent,
      local: values.local || '',
    })
      .then(() => {
        dispatch(reset('EventScreenForm'));
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
        onBackClick();
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
        updatePendency(dispatch);
      });
  };

  const setEventHeaderRelatedObjects = (value) => {
    dispatch(change('EventScreenForm', 'relatedObjects', value));
  };

  const onRelatedObjectsChange = (values) => {
    if (values) {
      setEventHeaderRelatedObjects(values);
    } else {
      setEventHeaderRelatedObjects([]);
    }
  };

  const findCalendarByCommunicationId = (communicationId) => {
    showLoading();
    const query = eventCalendarFindByCommunicationId(communicationId);
    GraphQl(query, {})
      .then(({ eventCalendarFindById }) => {
        const updatedDto = {
          ...eventCalendarFindById,
          calendar: {
            ...eventCalendarFindById.calendar,
            label: eventCalendarFindById.calendar.name,
            value: eventCalendarFindById.calendar.value,
          },
        };
        setDto(updatedDto);
        setCalendarNotifications(updatedDto.lstNotifications);
        const relatedObjs = updatedDto.communication.relatedObjects.map(
          (item) => ({
            ...item,
            value: item.id,
            label: item.description,
          })
        );
        setEventHeaderRelatedObjects(relatedObjs);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  useEffect(() => {
    if (event) {
      if (event.communication.id) {
        findCalendarByCommunicationId(event.communication.id);
      } else {
        setDto(event);
      }
    }
  }, [event]);

  useEffect(() => {
    loadAllCalendar();
    loadRelatedObjects();
    if (match && match.params.id && match.params.id > 0) {
      if (dto.communication.id !== parseInt(match.params.id, 0)) {
        findCalendarByCommunicationId(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  return (
    <>
      {formOn && (
        <>
          <EventForm
            dto={dto}
            calendars={calendars}
            onSubmit={handleSubmit}
            relatedObjects={relatedObjects}
            removeItemClickHandler={removeEvent}
            loadEventMetrics={loadEventMetrics}
            metricsData={metricsData}
            loadCalendarAlerts={loadCalendarAlerts}
            calendarNotifications={calendarNotifications}
            onRelatedObjectsChange={onRelatedObjectsChange}
            mappedChartData={mappedChartData}
          />
        </>
      )}
    </>
  );
};

EventFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  foreignToggleClose: PropTypes.func.isRequired,
  match: ReactRoutePropTypes.match.isRequired,
  history: ReactRoutePropTypes.history.isRequired,
  event: PropTypes.shape({
    communication: PropTypes.shape({
      id: PropTypes.number,
    }),
  }),
};

EventFormHandler.defaultProps = {
  event: undefined,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(EventFormHandler)
);
